
export default class StateAddress {

    Id: string;
    Description: string;

    constructor(id: string, description: string) {
        this.Id = id;
        this.Description = description;
    }

    static NewInstance() {
        return new StateAddress("", "");
    }
}